<template>
  <div>
    <div v-for="item in list" :key="item.id">
      <div class="grid2">
        <div class="grid2-cell">
          {{item.科目番号}} {{item.科目名}}
        </div>
        <div class="grid2-cell2">
          <div>{{item.単位数 | decimal}} ({{item.総合評価}})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DecimalFilter} from '@/components/mixins/DecimalFilter'
export default {
  name: 'result-credit2-view',
  mixins: [DecimalFilter],
  props: {
    list: {
      type: Array,
      required: true
    }
  },
}
</script>

<style>

</style>
